import DesEditTeamSubPanelViewModel from 'viewmodel/DesEditTeamSubPanelViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesEditTeamSubPanel extends DesBaseCatalogAcc {
    constructor() {
        super(DesEditTeamSubPanelViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }
    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'email-template-id', 'email-template-params', 'collaborationspaceid', 'locale'];
    }

}
if (!window.customElements.get('des-edit-team-sub-panel')) {
    window.customElements.define('des-edit-team-sub-panel', DesEditTeamSubPanel);
}
